import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import useCurrentGlobalSearchVerticalPage from 'hooks/GlobalSearch/useCurrentGlobalSearchVerticalPage'
import useGlobalSearchURLHashVertical from 'hooks/GlobalSearch/useGlobalSearchURLHashVertical'
import useGlobalSearchVerticalTabs from 'hooks/GlobalSearch/useGlobalSearchVerticalTabs'
import { memo, useCallback, useMemo } from 'react'
import styled from 'styled-components'
import NavBarButton from '../NavBarButton/NavBarButton'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useIsSearchPage from 'hooks/Navigation/useIsSearchPage'
import useIsHomepage from 'home/hooks/isHomepage'
import { useLocation } from 'react-router'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

const IconSearchInput = styled(NavBarButton)`
  ${mediaQueryUp.tablet} {
    display: none;
  }
`

interface Props {
  className?: string
}

function NavBarSearchButton(props: Props) {
  const { className } = props
  const globalSearchVerticalTabs = useGlobalSearchVerticalTabs()
  const currentSearchVerticalPage = useCurrentGlobalSearchVerticalPage()
  const { toggleSearchVertical } = useGlobalSearchURLHashVertical()
  const location = useLocation()
  const isSearchPage = useIsSearchPage()
  const isHomepage = useIsHomepage()

  const hide = useMemo(() => {
    if (isHomepage) {
      // search is taken by the input version on home page
      return true
    } else if (isSearchPage) {
      const isMerchandiseSearchPage = matchLocaleAwarePath(location.pathname, { path: '/:regionCode/search/shop' })
      // don't need search on a search page (except merchandise)
      return !isMerchandiseSearchPage
    }
    return false
  }, [isHomepage, isSearchPage, location.pathname])

  const onSearchClick = useCallback(() => {
    const verticalTab = currentSearchVerticalPage ?? globalSearchVerticalTabs.keys().next().value
    toggleSearchVertical(verticalTab)
  }, [currentSearchVerticalPage, globalSearchVerticalTabs, toggleSearchVertical])

  if (hide) {
    return null
  }

  return <IconSearchInput
    className={className}
    icon={<LineSearchIcon />}
    onClick={onSearchClick}
  />
}

export default memo(NavBarSearchButton)
